"use strict";

var customSize = require('./customSize');

var doubleSided = require('./doubleSided');

var scored = require('./scored');

var programSize = require('./programSize');

var size = require('./size');

var sizeFolded = require('./sizeFolded');

var scoredAndFolded = require('./scoredAndFolded');

module.exports = {
  customSize: customSize,
  doubleSided: doubleSided,
  scored: scored,
  programSize: programSize,
  size: size,
  sizeFolded: sizeFolded,
  scoredAndFolded: scoredAndFolded
};